/** Айди предметов ЕГЭ для исключения */
export const egeSubjectsExсeptions = [34, 33, 152, 36, 421, 5]
